<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-batchad g-main-wrapper">
      <!-- filter -->
      <batchad-filter
        placeholder="请输入计划名称或任务ID"
        @on-retry="toBatchRetry"
        @on-edit="toBatchEdit"
        @on-change="filterData"
        @on-search="searchFilterData"
        @on-duplicate="onTaskDuplicate"
      />
      <!-- table -->
      <div class="c-table-list">
        <Viewport v-model="tableHeight">
          <batchad-table
            ref="batchadTable"
            v-model="selectionRow"
            :loading="loading"
            :data="tableList"
            :height="tableHeight"
            :columns="tableCol"
            @on-refresh="getData"
            @on-loading="reLoading"
          />
          <Page
            show-total
            show-sizer
            show-elevator
            :total="total"
            :current.sync="pageIndex"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            size="small"
            class="c-table-page pager"
            @on-change="changePageIndex"
            @on-page-size-change="changePageSize"
          />
        </Viewport>
      </div>
    </div>
    <batch-edit v-model="betchCopy" :data="betchCheck" :columns="checkColumns" @on-visible-change="resetModal" />

    <!-- 任务批量复制 -->
    <TasksDuplication
      ref="duplicateModal"
      v-model="showTaskDuplicateModal"
      :data="taskDupInfo"
      :columns="[
        {
          title: '媒体',
          key: 'mediaName',
          minWidth: 90
        },
        {
          title: '计划',
          key: 'copyPlan',
          minWidth: 220
        },
        {
          title: '操作',
          key: 'control',
          width: 100
        }
      ]"
    />
  </Layout>
</template>
<script>
import Cookies from 'js-cookie'
import mixin from '../mixins/mixin'
import columns from '../data/batch_ad_column'
import { setLocal, getLocal, setSession } from '@/common/js/api'
import { isArray, setLocalInfo, setStoreName, camelcase } from '@/common/js/utils'
import { listBatchTask, batchRetryTaskById } from '@/api/manage.model'

import BatchadFilter from './components/batchad-filter.vue'
import BatchadTable from './components/batchad-table.vue'
import BatchEdit from './components/batch-edit.vue'

import TasksDuplication from '@/components/converter/betch-copy.vue'

export default {
  name: 'batchAdList',
  mixins: [mixin],
  components: { TasksDuplication, BatchadFilter, BatchadTable, BatchEdit },

  methods: {
    getData(filter) {
      if (this.loading) return

      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      listBatchTask(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('BATCHAD_PAGESIZE', size)
    },

    getOpenUrl(media) {
      if (media === 10) return '/edit/local'
      else if (media === 16) return '/edit/tencent'
      else if (media === 6) return '/edit/uc'
      else if (media === 32) return '/edit/kuaishou'
      else if (media === 45) return '/edit/baidu'
      else return ''
    },
    toBatchEdit() {
      if (!this.selectionRow.length) {
        this.$Message.error('请选择批量失败任务')
        return
      }
      let media = ''
      const selectionRow = this.selectionRow.filter((row) => row.taskStatus === 3)

      if (!selectionRow.length) return this.$Message.warning('已选结果列表内没有失败任务')

      // const newToutiaoLength = selectionRow.filter((row) => row.version === 'TOUTIAO2.0').length
      const newToutiaoLength = selectionRow.filter((row) => row.version === 'Ttv3').length
      const toutiaoJubaoPlan = selectionRow.filter((row) => row.version === 'TtJubao')
      const toutiaoJubaoLength = toutiaoJubaoPlan.length

      const tencentADAPlan = selectionRow.filter((row) => row.version === 'GDT-ADA')
      const tencentADALength = tencentADAPlan.length

      // v3模板需要兼容v1腾讯广告搜索广告
      const tencentV3Plan = selectionRow.filter((row) => row.version === 'Gdtv3' || row.version === 'Gdtv1')
      const tencentV3Length = tencentV3Plan.length

      const isSingleToutiaoVersion =
        newToutiaoLength === selectionRow.length ||
        toutiaoJubaoLength === selectionRow.length ||
        (!newToutiaoLength && !toutiaoJubaoLength)
      if (selectionRow.every((row) => row.mediaId === selectionRow[0].mediaId) && isSingleToutiaoVersion) {
        media = selectionRow[0].mediaId
      } else this.betchCopy = true

      if (media && !newToutiaoLength && !toutiaoJubaoLength && !tencentADALength && !tencentV3Length) {
        // 单媒体不含头条2、不含ada
        if ([16, 10, 6, 32, 45].includes(media)) {
          const openUrl = this.getOpenUrl(media)
          const account = Cookies.get('ch_user_name')
          const id = Cookies.get('ch_op_id')
          const editTaskIds = selectionRow
            .filter((row) => {
              // const faild = row.updateFlag && [4, 5, 6].includes(row.taskProgress)
              const faild = row.updateFlag
              const editMedia = row.mediaId === media
              return editMedia && faild
            })
            .map((ret) => ret.taskId)
          const taskIds = selectionRow.filter((ret) => !editTaskIds.includes(ret.taskId)).map((ret) => ret.taskId)
          if (editTaskIds.length > 20) {
            const number = editTaskIds.length - 20
            editTaskIds.splice(20, number)
          }
          if (taskIds.length && editTaskIds.length) {
            this.$Modal.confirm({
              title: '系统提示',
              content: `满足批量修改条件的任务ID有【${editTaskIds.join('，')}】，任务ID【${taskIds.join(
                '，'
              )}】将不能加入到修改页面中进行修改，请知悉`,
              okText: '知道了',
              onOk: () => {
                const storeName = setStoreName(media)
                setLocalInfo(id, account, media.toString())
                setSession('taskIds', editTaskIds)
                this.$store.commit(`${camelcase(storeName)}/setMedia`, media)
                this.$store.commit(`${camelcase(storeName)}/setOpId`, id)
                this.$store.commit(`${camelcase(storeName)}/setAdmin`, account)
                this.getData()
                window.open(openUrl, '_blank')
              }
            })
          } else if (editTaskIds.length) {
            setLocalInfo(id, account, media.toString())
            setSession('taskIds', editTaskIds)
            // this.getData()
            window.open(openUrl, '_blank')
          } else {
            this.$Modal.error({
              title: '系统提示',
              content: `未选择满足修改条件的任务，任务ID【${taskIds.join('，')}】将不能加入到修改页面中进行修改，请知悉`,
              okText: '知道了'
            })
          }
        } else {
          this.$Modal.error({
            title: '系统提示',
            content: '暂不支持该媒体类型的批量修改',
            okText: '知道了'
          })
        }
      } else if (tencentADALength === selectionRow.length) {
        const taskIds = selectionRow.map((row) => row.taskId)
        setSession('taskIds', taskIds)
        window.open('/edit/tencentada', '_blank')
      } else if (tencentV3Length === selectionRow.length) {
        const taskIds = selectionRow.map((row) => row.taskId)
        setSession('taskIds', taskIds)
        window.open('/edit/tencentv3', '_blank')
      } else if (newToutiaoLength === selectionRow.length || toutiaoJubaoLength === selectionRow.length) {
        // 全是同版本的头条2.0或智擎任务
        const account = Cookies.get('ch_user_name')
        const id = Cookies.get('ch_op_id')
        const storeName = setStoreName(media)
        const taskIds = selectionRow.map((row) => row.taskId)
        setLocalInfo(id, account, media.toString())
        setSession('taskIds', taskIds)
        this.$store.commit(`${camelcase(storeName)}/setMedia`, media)
        this.$store.commit(`${camelcase(storeName)}/setOpId`, id)
        this.$store.commit(`${camelcase(storeName)}/setAdmin`, account)
        this.getData()
        window.open('/edit/toutiaov2', '_blank')
      } else {
        // 多媒体 或者 同时包含1.0和2.0的头条
        // const toutiaoPlan = selectionRow.filter((row) => row.mediaId === 10 && row.version !== 'TOUTIAO2.0')
        const toutiaoPlan2 = selectionRow.filter((row) => row.mediaId === 10 && row.version === 'Ttv3')
        const tencentPlan = selectionRow.filter((row) => row.mediaId === 16 && !row.version)
        const kuaishouPlan = selectionRow.filter((row) => row.mediaId === 32)
        const baiduPlan = selectionRow.filter((row) => row.mediaId === 45)

        if (toutiaoPlan2.length) {
          const editTaskIds = toutiaoPlan2.filter((row) => row.updateFlag).map((ret) => ret.taskId)
          const failIds = toutiaoPlan2.filter((ret) => !editTaskIds.includes(ret.taskId)).map((ret) => ret.taskId)
          const planInfos = toutiaoPlan2.filter((ret) => editTaskIds.includes(ret.taskId))
          this.betchCheck.push({
            mediaName: '巨量引擎2.0',
            mediaId: 10,
            copyPlan: editTaskIds.slice(0, 5),
            length: editTaskIds.length,
            failIds: failIds.slice(0, 5),
            failLength: failIds.length,
            planInfos
          })
        }

        if (toutiaoJubaoLength) {
          const editTaskIds = toutiaoJubaoPlan.filter((row) => row.updateFlag).map((ret) => ret.taskId)
          const failIds = toutiaoJubaoPlan.filter((ret) => !editTaskIds.includes(ret.taskId)).map((ret) => ret.taskId)
          const planInfos = toutiaoJubaoPlan.filter((ret) => editTaskIds.includes(ret.taskId))
          this.betchCheck.push({
            mediaName: '巨量智擎',
            mediaId: -40,
            copyPlan: editTaskIds.slice(0, 5),
            length: editTaskIds.length,
            failIds: failIds.slice(0, 5),
            failLength: failIds.length,
            planInfos
          })
        }

        if (tencentADALength) {
          const editTaskIds = tencentADAPlan
            .filter((row) => {
              // const faild = row.updateFlag && [4, 5, 6].includes(row.taskProgress)
              const faild = row.updateFlag
              return faild
            })
            .map((ret) => ret.taskId)
          const failIds = tencentADAPlan.filter((ret) => !editTaskIds.includes(ret.taskId)).map((ret) => ret.taskId)
          const planInfos = tencentADAPlan.filter((ret) => editTaskIds.includes(ret.taskId))

          this.betchCheck.push({
            mediaName: '腾讯ADA',
            mediaId: 16,
            copyPlan: editTaskIds.slice(0, 5),
            length: editTaskIds.length,
            failIds: failIds.slice(0, 5),
            failLength: failIds.length,
            planInfos
          })
        }

        if (tencentV3Length) {
          const editTaskIds = tencentV3Plan
            .filter((row) => {
              const faild = row.updateFlag && [4, 5, 6].includes(row.taskProgress)
              return faild
            })
            .map((ret) => ret.taskId)
          const failIds = tencentV3Plan.filter((ret) => !editTaskIds.includes(ret.taskId)).map((ret) => ret.taskId)
          const planInfos = tencentV3Plan.filter((ret) => editTaskIds.includes(ret.taskId))

          this.betchCheck.push({
            mediaName: '腾讯v3',
            mediaId: 16,
            copyPlan: editTaskIds.slice(0, 5),
            length: editTaskIds.length,
            failIds: failIds.slice(0, 5),
            failLength: failIds.length,
            planInfos
          })
        }

        if (tencentPlan.length) {
          const editTaskIds = tencentPlan
            .filter((row) => {
              const faild = row.updateFlag && [4, 5, 6].includes(row.taskProgress)
              return faild
            })
            .map((ret) => ret.taskId)
          const failIds = tencentPlan.filter((ret) => !editTaskIds.includes(ret.taskId)).map((ret) => ret.taskId)
          const planInfos = tencentPlan.filter((ret) => editTaskIds.includes(ret.taskId))
          this.betchCheck.push({
            mediaName: '腾讯',
            mediaId: 16,
            copyPlan: editTaskIds.slice(0, 5),
            length: editTaskIds.length,
            failIds: failIds.slice(0, 5),
            failLength: failIds.length,
            planInfos
          })
        }
        if (kuaishouPlan.length) {
          const editTaskIds = kuaishouPlan
            .filter((row) => {
              const faild = row.updateFlag && [4, 5, 6].includes(row.taskProgress)
              return faild
            })
            .map((ret) => ret.taskId)
          const failIds = kuaishouPlan.filter((ret) => !editTaskIds.includes(ret.taskId)).map((ret) => ret.taskId)
          const planInfos = kuaishouPlan.filter((ret) => editTaskIds.includes(ret.taskId))
          this.betchCheck.push({
            mediaName: '磁力引擎',
            mediaId: 32,
            copyPlan: editTaskIds.slice(0, 5),
            length: editTaskIds.length,
            failIds: failIds.slice(0, 5),
            failLength: failIds.length,
            planInfos
          })
        }

        if (baiduPlan.length) {
          const editTaskIds = baiduPlan
            .filter((row) => {
              const faild = row.updateFlag && [4, 5, 6].includes(row.taskProgress)
              return faild
            })
            .map((ret) => ret.taskId)
          const failIds = baiduPlan.map((ret) => ret.taskId)
          const planInfos = baiduPlan.filter((ret) => editTaskIds.includes(ret.taskId))
          this.betchCheck.push({
            mediaName: '百度信息流',
            mediaId: 45,
            copyPlan: editTaskIds.slice(0, 5),
            length: 0,
            failIds: failIds.slice(0, 5),
            failLength: failIds.length,
            planInfos
          })
        }
      }
    },
    resetModal(val) {
      if (!val) this.betchCheck = []
    },
    reLoading(val) {
      this.loading = val
    },

    /**
     * @description: 根据媒体类型分割已选任务
     */
    splitMediaTypes() {
      const medieCates = {}

      this.selectionRow.forEach((row) => {
        if (row.version === 'Ttv3') {
          if (!medieCates[-10]) {
            medieCates[-10] = {
              mediaName: '巨量引擎2.0',
              mediaId: -10,
              tasks: []
            }
          }
          medieCates[-10].mediaName = '巨量引擎2.0'
          medieCates[-10].tasks.push(row)
        } else if (row.version === 'TtJubao') {
          if (!medieCates[-40]) {
            medieCates[-40] = {
              mediaName: '巨量智擎',
              mediaId: -40,
              tasks: []
            }
          }
          medieCates[-40].mediaName = '巨量智擎'
          medieCates[-40].tasks.push(row)
        } else if (row.version === 'GDT-ADA') {
          if (!medieCates[-20]) {
            medieCates[-20] = {
              mediaName: '腾讯ADA',
              mediaId: -20,
              tasks: []
            }
          }
          medieCates[-20].mediaName = '腾讯ADA'
          medieCates[-20].tasks.push(row)
        } else if (row.version === 'Gdtv3') {
          if (!medieCates[-30]) {
            medieCates[-30] = {
              mediaName: '腾讯v3',
              mediaId: -30,
              tasks: []
            }
          }
          medieCates[-30].mediaName = '腾讯v3'
          medieCates[-30].tasks.push(row)
        } else {
          if (!medieCates[row.mediaId]) {
            medieCates[row.mediaId] = {
              mediaName: '',
              mediaId: row.mediaId,
              tasks: []
            }
          }
          medieCates[row.mediaId].mediaName = row.mediaName
          medieCates[row.mediaId].tasks.push(row)
        }
      })

      return medieCates
    },
    /**
     * @description: 显示任务批量复制确认弹窗
     */
    onTaskDuplicate() {
      const mediaTypes = this.splitMediaTypes()

      this.taskDupInfo = Object.values(mediaTypes).map((m) => {
        const planInfos = m.tasks
        return {
          mediaId: m.mediaId,
          mediaName: m.mediaName,
          length: m.tasks.length,
          planInfos,
          copyPlan: m.tasks.slice(0, 5).map((task) => task.taskId),
          megerCreative: m.mediaId === -30 && planInfos.length > 1
        }
      })
      const [firstTask] = this.taskDupInfo
      // 如果只有一个媒体，或者没有合并创意组的条件，直接打开新页签
      if (this.taskDupInfo.length === 1 && !firstTask.megerCreative) {
        this.$refs.duplicateModal.toBatchEdit(this.taskDupInfo[0])
      } else {
        this.showTaskDuplicateModal = true
      }
    },
    toBatchRetry() {
      const taskIds = this.selectionRow.filter((row) => row.taskStatus === 3).map((ret) => ret.taskId)
      if (taskIds.length) {
        this.$Modal.confirm({
          title: '批量重试',
          content: `<p>已选择 <span style="color:#ff4400">${taskIds.length}</span> 条任务，确定要重试？</p>`,
          onOk: () => {
            batchRetryTaskById({ taskIds })
              .then((data) => {
                if (data) {
                  this.getData()
                } else this.$Message.error('批量重试任务失败')
              })
              .catch((err) => {
                console.error(err)
              })
          }
        })
      } else {
        this.$Message.error('请选择批量重试任务')
      }
    }
  },
  data() {
    const checkColumns = [
      {
        title: '媒体',
        key: 'mediaName',
        minWidth: 90
      },
      {
        title: '计划',
        key: 'copyPlan',
        minWidth: 220
      },
      {
        title: '操作',
        key: 'control',
        width: 100
      }
    ]
    return {
      showTaskDuplicateModal: false,
      taskDupInfo: [],
      tableHeight: 500,
      collapsible: null, // 展开过滤器
      selectionRow: [],
      betchCopy: false, // 批量修改弹框
      checkColumns,
      betchCheck: []
    }
  },
  created() {
    this.tableCol = columns
    this.pageSize = parseInt(getLocal('BATCHAD_PAGESIZE')) || 20
  }
}
</script>
<style lang="scss" scoped>
.c-batchad {
  height: 100%;
  padding: 8px 8px 0;

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
